module.exports = __webpack_public_path__ + "i18n/en_f3da5642647b7b1b52736e84fcc6a71b.json";


//////////////////
// WEBPACK FOOTER
// ./app/assets/i18n/en.json
// module id = aY29
// module chunks = 153